import React from 'react';

import BoxComponent from '../../BoxComponent/BoxComponent';
import { AssignedToProps } from './AssignedTo.interface';
import { SypacText } from '@sypac/component-library-react';
import UserAvatar from '../../UserAvatar/UserAvatar';

const AssignedTo = ({
	notification,
	title,
	description,
	avatar,
	username,
}: AssignedToProps) => {
	return (
		<BoxComponent notification={notification}>
			<div className="flex flex-col p-3 gap-3">
				<SypacText variant="body-regular-medium">
					<p className="text-gray-80">{title}</p>
				</SypacText>
				<div className="flex flex-row gap-3 items-center">
					<UserAvatar size="sm" name={username} photoUrl={avatar} />
					<SypacText variant="body-regular-medium">
						<p className="text-gray-80">{username}</p>
					</SypacText>
				</div>
				{description ? (
					<SypacText variant="overline-regular-large">
						<p className="text-gray-80 leading-3">{description}</p>
					</SypacText>
				) : null}
			</div>
		</BoxComponent>
	);
};

export default AssignedTo;
